import React, { useState } from "react";
import Form from "components/shared/Form/form";
import ToastService from "shared/toastService";
import MarkdownEditor from "components/shared/MarkdownEditor/MarkdownEditor";

import "./metaForm.scss";
import photoApi from "api/photoApi";
import { PHOTO_API_URL } from "api/const";

const MetaForm = ({ metaData, onChange, formId, isGuestForm }) => {
  const [coverError, setCoverError] = useState(false);

  const onSubmitImageUpload = (imageURL) => {
    onChange({ ...metaData, cover: imageURL });
  };

  const onSubmitImage = (payload) => {
    // Clear previous error when a new file is selected
    setCoverError(false);

    photoApi
      .uploadCover(formId, payload)
      .then((data) => {
        if (data.error) {
          setCoverError(true);
          ToastService.makeErrorToast({
            title: "Image upload failed",
            text:
              data?.message ||
              "We couldn't upload your image. Please try again.",
          });
          return;
        }
        setCoverError(false);
        onSubmitImageUpload(`${PHOTO_API_URL}${data.path}`);
      })
      .catch((error) => {
        console.log("error", error);
        setCoverError(true);
        ToastService.makeErrorToast({
          title: "Image upload failed",
          text: "Something went wrong. Please try again.",
        });
      });
  };

  const fields = [
    {
      name: "name",
      label: "Title",
      type: "text",
      value: metaData?.name || "",
      placeholder: "Enter the form name",
    },
    {
      name: "description",
      label: "Description",
      explainer:
        "A brief summary or detailed explanation of the purpose and contents of the form.",
      type: "custom",
      value: metaData?.description || "",
      placeholder: "Enter the form description",
      component: MarkdownEditor,
    },
    ...(!isGuestForm
      ? [
          {
            type: "file",
            name: "cover",
            label: "Select Image",
            errorMessage:
              "We couldn't upload your image. Please try again.",
            isInvalid: coverError,
            onFileUpload: onSubmitImage,
          },
        ]
      : []),
  ];
  return (
    <div className="meta-form">
      <Form
        name="meta-form"
        fields={fields}
        onChange={onChange}
        formName=""
        values={metaData}
      />
    </div>
  );
};

export default MetaForm;
